import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BannerComponent } from './shared/notifications/banner/banner.component';

@Component({
  selector: 'tw-root',
  imports: [RouterOutlet, BannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
